import type { ReactNode } from 'react';

import type { Acl as AclType } from 'types/acl';

import checkAcl from './check-acl';
import mapAclToPermissions from './map-acl-to-permissions';

type Props = {
  acl: AclType,
  check: string | string[],
  children: ReactNode,
  match?: 'all' | 'any',
};

const Acl = ({
  acl,
  check,
  children,
  match = 'all',
}: Props) => {
  if (checkAcl(mapAclToPermissions(acl), check, { match })) {
    return children;
  }
  return null;
};

export default Acl;
